<!-- transclude formation groups -->
<ng-content></ng-content>
<!-- load formation groups template -->
@for (groupTemplate of formationService.groupTemplates$ | async; track trackByFn($index, groupTemplate)) {
    <!--
    If groupTemplate.visible is undefined, then no condition is specified - treat undefined as true
    If groupTemplate.visible is already an async pipe (or equivalent), then it will resolve to null until it is resolved - treat null as false
    If groupTemplate.visible is a Promise, pipe it through async
    Otherwise, treat groupTemplate.visible as a boolean
    -->
    @if (groupTemplate.visible === undefined || (groupTemplate.visible !== null && (isPromise(groupTemplate.visible) ? ($any(groupTemplate.visible) | async) : groupTemplate.visible))) {
        <fui-formation-group #formationGroup
                             [class]="groupTemplate.formationClass"
                             [title]="groupTemplate.title"
                             [formationType]="groupTemplate.formationType"
                             [formControlNames]="groupTemplate.formControlNames">
            @if (formationGroup.hasLoaded) {
                <ng-template [ngTemplateOutlet]="groupTemplate.template"></ng-template>
            }
        </fui-formation-group>
    }
}
